import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
  DrawerTitle,
  typographyVariants,
} from '@mint-lib/tw-components';

import { useKnowledgeBase } from '../../hooks/useKnowledgeBase.js';
import KnowledgeBase from './KnowledgeBase.jsx';

const RagDrawer = () => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  const { isOpen, toggle } = useKnowledgeBase();

  return (
    <Drawer open={isOpen} onOpenChange={toggle}>
      <DrawerPortal>
        <DrawerOverlay className="duration-500" />
        <DrawerRoot aria-describedby={undefined} className="duration-500">
          <DrawerHeader>
            <DrawerTitle className={typographyVariants({ variant: 'h3' })}>
              {t('Knowledge base')}
            </DrawerTitle>
          </DrawerHeader>
          <DrawerContent className="flex justify-center gap-4">
            <div className="flex h-full w-[75vw] flex-col">
              <KnowledgeBase />
            </div>
          </DrawerContent>
        </DrawerRoot>
      </DrawerPortal>
    </Drawer>
  );
};

export { RagDrawer };
